import Route from '@ember/routing/route';
import { task, timeout } from 'ember-concurrency';
import { KIOSK_ENTRY_URL_KEY, KIOSK_TRY_AGAIN_RECOVERY_DELAY_MS } from 'invite-sign/utils/kiosk-recovery';
import zft from 'invite-sign/utils/zero-for-tests';

export default class TryAgainRoute extends Route {
  beforeModel(): void {
    const loader = document.getElementById('initial-loader');
    if (loader) {
      loader.style.display = 'none';
    }
  }

  // On a shared-device kiosk this screen's "scan the QR code again" advice is
  // a dead end (there is no QR code) — staff were rebooting the device to
  // recover (SQ-7544). When the kiosk entry URL is known, pause briefly and
  // then navigate back to it, which re-authenticates the device and lands on
  // the welcome screen. QR / personal-invite flows are unaffected.
  activate(): void {
    if (this.kioskEntryUrl) void this.kioskRecoveryTask.perform();
  }

  deactivate(): void {
    void this.kioskRecoveryTask.cancelAll();
  }

  get kioskEntryUrl(): string | null {
    try {
      return sessionStorage.getItem(KIOSK_ENTRY_URL_KEY);
    } catch {
      return null;
    }
  }

  kioskRecoveryTask = task({ drop: true }, async (): Promise<void> => {
    await timeout(zft(KIOSK_TRY_AGAIN_RECOVERY_DELAY_MS));

    this.recoverKiosk();
  });

  recoverKiosk(): void {
    const isLiveEnv = zft(1) > 0;
    const entryUrl = this.kioskEntryUrl;

    if (isLiveEnv && entryUrl) window?.location?.replace?.(entryUrl);
  }
}
